module.exports = __webpack_public_path__ + "media/images/ipaf-b64a8c5fbda78c0ba03c3511cb916cb1.svg";